import { PaymentMethods } from 'types/beneficiaries'

export const PaymentMethodStatusColourMapping = {
  [PaymentMethods.ACH]: 'success',
  [PaymentMethods.CUBIX]: 'feature',
  [PaymentMethods.FEDWIRE]: 'neutral',
} as const

export const PayoutBeneficiaryFilters = {
  MY_COMPANY: 'my-company',
  BUSINESS: 'business',
  INDIVIDUAL: 'individual',
}

export type PayoutBeneficiaryFilter =
  (typeof PayoutBeneficiaryFilters)[keyof typeof PayoutBeneficiaryFilters]

export const MAX_GBP_PAYMENT_AMOUNT = 1000000

export const FeeErrors = {
  BVNK_0000: 'bvnk:0000',
  BAD_REQUEST_ERROR: 'bvnk:payment:0001',
  BENEFICIARY_VALIDATION_ERROR: 'bvnk:payment:0005',
}

export const IBAN_PATTERN = /^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/

export const FIAT_SEND_ERRORS = {
  INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
  PAYMENT_NOT_SUPPORTED: 'PAYMENT_NOT_SUPPORTED',
} as const

export const FIAT_SEND_EOF = {
  SUCCESS: 'SUCCESS',
  APPROVAL: 'APPROVAL',
} as const

export const PAYOUT_VERSIONS = {
  LEGACY_WITHDRAW: 'LEGACY_WITHDRAW',
  LEGACY_PAY: 'LEGACY_PAY',
  UNIFIED_PAYOUT_V2: 'UNIFIED_PAYOUT_V2',
} as const

export const SEPA_METHODS = new Set<string>([PaymentMethods.SEPA, PaymentMethods.SEPA_INSTANT])

export const PAYOUT_FIELD_LABEL_MAPPING: Record<string, string> = {
  'beneficiary.bankAccount.bank.name': 'Bank name',
  'beneficiary.bankAccount.bank.swiftCode': 'SWIFT code',
  'beneficiary.bankAccount.bank.code': 'Bank code',
  'beneficiary.bankAccount.bank.address.addressLine1': 'Bank address line 1',
  'beneficiary.bankAccount.bank.address.addressLine2': 'Bank address line 2',
  'beneficiary.bankAccount.bank.address.city': 'Bank city',
  'beneficiary.bankAccount.bank.address.region': 'Bank region',
  'beneficiary.bankAccount.bank.address.postCode': 'Bank postal code',
  'beneficiary.bankAccount.bank.address.country': 'Bank country',
  'beneficiary.bankAccount.accountNumber': 'Account number',
  'beneficiary.bankAccount.iban': 'IBAN',
  'beneficiary.bankAccount.sortCode': 'Sort code',
  'beneficiary.bankAccount.routingNumber': 'Routing number',
  'beneficiary.bankAccount.bic': 'BIC',
  'beneficiary.name': 'Beneficiary name',
  'beneficiary.address.addressLine1': 'Beneficiary address line 1',
  'beneficiary.address.addressLine2': 'Beneficiary address line 2',
  'beneficiary.address.city': 'Beneficiary city',
  'beneficiary.address.region': 'Beneficiary region',
  'beneficiary.address.postCode': 'Beneficiary postal code',
  'beneficiary.address.country': 'Beneficiary country',
  'beneficiary.remittanceInformation': 'Payment reference',
  'originator.amount': 'Amount',
  'originator.currency': 'Currency',
  'originator.walletId': 'Originator wallet ID',
  'intermediaryBanks.name': 'Intermediary bank name',
  'intermediaryBanks.swiftCode': 'Intermediary bank SWIFT code',
  'intermediaryBanks.identificationCode': 'Intermediary bank code',
  'intermediaryBanks.address.addressLine1': 'Intermediary bank address',
  'intermediaryBanks.address.city': 'Intermediary bank city',
  'intermediaryBanks.address.region': 'Intermediary bank region',
  'intermediaryBanks.address.postCode': 'Intermediary bank postal code',
  'intermediaryBanks.address.country': 'Intermediary bank country',
  amount: 'Amount',
  currency: 'Currency',
  walletId: 'Wallet',
  paymentMethod: 'Payment method',
  value: 'Amount',
}

export const ELIGIBILITY_MESSAGE_MAPPING: Record<string, string> = {
  FIRST_PARTY: 'wallets.fiatSend.eligibilityMessageMapping.firstParty',
  PAYMENT_METHOD_UNAVAILABLE: 'wallets.fiatSend.eligibilityMessageMapping.paymentMethodUnavailable',
  THIRD_PARTY_TO_INDIVIDUALS: 'wallets.fiatSend.eligibilityMessageMapping.thirdPartyToIndividuals',
  THIRD_PARTY_TO_BUSINESSES: 'wallets.fiatSend.eligibilityMessageMapping.thirdPartyToBusinesses',
} as const
